export default __webpack_public_path__ + "static/media/investor-ecosystem.1837a2c0.svg";